import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../api/fetchJson';
import { QUOTES_URL } from '../../../api/endpoints';
import { Quotes } from '../types';

export function useGetQuotes() {
  const { data, isPending, error } = useQuery({
    queryKey: ['quotes'],
    queryFn: () => fetchJson<Quotes>(QUOTES_URL),
  });

  return {
    quotes: data,
    isLoadingQuotes: isPending,
    error,
  };
}
